/**
 * Component: Agenda
 * Package: Agenda
 * Author: Memorandum Multimedia S.L. - Arturo Soto
 * Copyright  Copyright (c) 2018 - Presente,  Memorandum Multimedia S.L. (https://memorandum.net)
 * License: Privated
 * Since  Version 1.0.0
 * Filesource: \gesipor\front\src\components\agenda\Agenda.js
 *
 * Requisito funcional: RQ06-001
 *
 * Estado testeado: KO
 *
 * Observaciones: Genera una calendario que permite administrar tareas y citas.
 */

import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import momentPlugin from '@fullcalendar/moment'
import bootstrapPlugin from '@fullcalendar/bootstrap'
import esLocale from '@fullcalendar/core/locales/es'
import enLocale from '@fullcalendar/core/locales/en-gb'
import chLocale from '@fullcalendar/core/locales/zh-cn'
import ruLocale from '@fullcalendar/core/locales/ru'
import jaLocale from '@fullcalendar/core/locales/ja'
import SimplePage from '../../containers/page/SimplePage'
import SimpleTablePage from '../../containers/comun/table/SimpleTablePage'
import SimpleModalPage from '../../containers/comun/modal/SimpleModalPage'
import MensajeAlertaPage from '../../containers/comun/mensajeAlerta/MensajeAlertaPage'
import FiltrosAgendaPage from '../../containers/agenda/FiltrosAgendaPage'
import ModalAgendaPage from '../../containers/agenda/ModalAgendaPage'
import './Agenda.scss'
import {colorTipoTareasAgenda} from '../comun/table/Stilyzers'
import {date_parser, dateTimeZones} from '../../util/formatFunctions'
import {permisos as permisosConstant} from '../../constants/permisos'

function getLocale(idioma) {
  let locales = {
    es: 'es',
    en: 'en-gb',
    ch: 'zh-cn',
    ru: 'ru',
    ja: 'ja',
    ko: 'ko'
  }
  return locales[idioma]
}

class Agenda extends Component {
  constructor (props) {
    super()
    this.state = {
      mostrarOpcionesEventId: null,
      ocultarOpcionesEventId: null
    }
    //this.myRef = React.createRef();
    this.abrirModalAgenda = this.abrirModalAgenda.bind(this)
  }

  abrirModalAgenda (idAgenda) {
    this.props.actions.abrirModalAgenda(idAgenda)
  }

  componentDidMount () {
    document.title = this.props.t('MENU.UTILIDADES.AGENDA') + ' - ' + this.props.t('HEADER.TITLE_GESIPOR')
    if (!this.props.auth.operario) {
      let fechaActual = date_parser(new Date(), this.props.auth.formaFechaHora)
      this.props.actions.fetchAgenda({fechaDesde: fechaActual})
      this.props.actions.fetchTareasDia({fechaDesde: fechaActual})
    } else {
      this.props.actions.fetchAgenda({})
      this.props.actions.fetchTareasDia({})
    }
  }

  render () {
    const {
      listTareasCalendario = [], listTareasDiarias = [], t, auth: {idioma}
    } = this.props
    let locale = getLocale(idioma)

    let comboTipoTareasAgenda = this.props.combos.comboTipoTareasAgenda
    comboTipoTareasAgenda = comboTipoTareasAgenda.map((tipoTarea) => {
      return {...tipoTarea, label: t('COMUN.COMBOS.' + tipoTarea.label)}
    })

    const tKey = 'AGENDA.'
    const idElementoTipoTareasAgendaTable = 'idTipoTareasAgenda'
    const tableTipoTareasAgenda = {
      id: 'tipoTareasAgendaTable',
      multiHeader: false,
      hasCheckbox: false,
      idElemento: idElementoTipoTareasAgendaTable,
      hasOptions: false,
      mostrarModificar: false,
      mostrarDuplicar: false,
      mostrarEliminar: false,
      hasPagination: false,
      columns: [
        {id: 'label', name: t(tKey + 'TABLA_TIPOS_TAREAS.COLUMNS.CLASIFICACION_TAREA')},
        {id: 'backgroundColor', name: t(tKey + 'TABLA_TIPOS_TAREAS.COLUMNS.COLOR'), stilyzer: colorTipoTareasAgenda},
      ],
      rows: comboTipoTareasAgenda,
      initialValues: {}
    }

    const idElementoTareasDiariasTable = 'idTareasDiariasAgenda'
    const tableTareasDiariasAgenda = {
      id: 'tareasDiariasAgendaTable',
      multiHeader: false,
      hasCheckbox: false,
      idElemento: idElementoTareasDiariasTable,
      hasOptions: false,
      mostrarModificar: false,
      mostrarDuplicar: false,
      mostrarEliminar: false,
      hasPagination: false,
      paginarConScroll: true,
      columns: [
        {id: 'nombreOperario', name: t(tKey + 'TABLA_TAREAS_DIARIAS.COLUMNS.OPERARIO')},
        {id: 'nombre', name: t(tKey + 'TABLA_TAREAS_DIARIAS.COLUMNS.NOMBRE_TAREA')},
        {id: 'fecha', name: t(tKey + 'TABLA_TAREAS_DIARIAS.COLUMNS.FECHA'), type: 'fecha'},
      ],
      rows: listTareasDiarias,
      initialValues: {},
      numeroRegistrosPorPagina: listTareasDiarias.length
    }

    return (
      <SimplePage t_key={tKey}>
        <SimpleModalPage/>
        <MensajeAlertaPage/>
        <ModalAgendaPage />
        <Row>
          <Col sm={12}>
            <FiltrosAgendaPage />
          </Col>
          <Col sm={3}>
            <Row>
              <Col sm={12}>
                <SimpleTablePage {...tableTipoTareasAgenda} />
              </Col>
              <Col sm={12}>
                <SimpleTablePage {...tableTareasDiariasAgenda} />
              </Col>
            </Row>
          </Col>
          <Col sm={9}>
            <FullCalendar
              plugins={[ dayGridPlugin, timeGridPlugin, interactionPlugin, momentPlugin, bootstrapPlugin ]}
              locales={[esLocale, enLocale, chLocale, ruLocale, jaLocale]}
              locale={locale}
              themeSystem="bootstrap"
              bootstrapFontAwesome={false}
              aspectRatio={2}
              contentHeight="auto"
              header={{
                left: 'timeGridDay,timeGridWeek,dayGridMonth',
                center: 'title',
                right:  'today prev,next'
              }}
              buttonText={{prev: '⟨', next: '⟩'}}
              views={{
                timeGridDay: {
                  type: 'timeGridDay'
                },
                timeGridWeek: {
                  type: 'timeGridWeek',
                  slotEventOverlap: false
                },
                dayGridMonth: {
                  type: 'dayGridMonth'
                }
              }}
              defaultView="dayGridMonth"
              nowIndicator={true}
              now={dateTimeZones(this.props.auth.zonaHorariaString)}
              events={listTareasCalendario}
              eventLimit={true}
              eventRender={(info) => {
                // info.el.firstChild.innerHTML = '<div>' + info.el.firstChild.innerHTML + '</div>' // First place to hook DOM.

                const thisAgenda = this
                info.el.addEventListener('dblclick', function(e) {
                  thisAgenda.abrirModalAgenda(info.event.id)

                  // Forzado eliminación tooltip, hay casos en los que aparece el tooltip y al abrir el modal el tooltip no desaparece
                  let tooltip = document.getElementsByClassName('tooltip')
                  if (tooltip && tooltip.length > 0) {
                    for (let i = 0; i < tooltip.length; i++) {
                      tooltip[i].classList.replace("in", "out")
                    }
                  }
                })

              // Añadir tooltip con la información completa del evento.
                let fcContent = {__html: "" + info.el.firstChild.innerHTML};
                const tooltip = (
                  <Tooltip id={"tooltipEventId" + info.event.id}>
                    <div dangerouslySetInnerHTML={fcContent} />
                  </Tooltip>
                )
                const overlayTriggerTooltip = (
                  <React.Fragment>
                    <OverlayTrigger placement="bottom" overlay={tooltip}>
                      <div className="overlayedContent" dangerouslySetInnerHTML={fcContent} />
                    </OverlayTrigger>
                  </React.Fragment>
                )
                ReactDOM.render(overlayTriggerTooltip, info.el.firstChild);


                // info.el.firstChild.appendChild(button) // Doesn't work with React.Fragment, only plain html/js
              }}
            />
          </Col>
        </Row>
      </SimplePage>
    )
  }
}

export default Agenda